import { apiClient } from "../../config";
import { env } from "../../../config/env";

import {
  GetArticlesResponse,
  GetArticleResponse,
  SuccessResponse,
} from "../../interface/articles.interface";

/**
 * ============================================
 * 📝 ADMIN ARTICLES SERVICE
 * ============================================
 */
class AdminArticlesService {

  /**
   * 📦 GET ALL
   */
  async getArticles(): Promise<GetArticlesResponse> {
    const response = await apiClient.get<GetArticlesResponse>(
      env.ARTICLES.ADMIN.BASE
    );

    return response.data;
  }

  /**
   * 📄 GET ONE
   */
  async getArticle(id: string): Promise<GetArticleResponse> {
    const response = await apiClient.get<GetArticleResponse>(
      `${env.ARTICLES.ADMIN.BASE}/${id}`
    );

    return response.data;
  }

  /**
   * ➕ CREATE
   */
  async createArticle(payload: FormData): Promise<SuccessResponse> {
    const response = await apiClient.post(
      env.ARTICLES.ADMIN.BASE,
      payload
    );

    return response.data;
  }

  /**
   * ✏️ UPDATE
   */
  async updateArticle(
    id: string,
    payload: any
  ): Promise<SuccessResponse> {
    const response = await apiClient.put(
      `${env.ARTICLES.ADMIN.BASE}/${id}`,
      payload
    );

    return response.data;
  }

  /**
   * 🖼️ UPDATE THUMBNAIL
   */
  async updateThumbnail(
    id: string,
    payload: FormData
  ): Promise<SuccessResponse> {
    const response = await apiClient.post(
      env.ARTICLES.ADMIN.THUMBNAIL(id),
      payload
    );

    return response.data;
  }

  /**
   * 🖼️ UPLOAD GALLERY
   */
  async uploadGallery(
    id: string,
    payload: FormData
  ): Promise<SuccessResponse> {
    const response = await apiClient.post(
      env.ARTICLES.ADMIN.GALLERY(id),
      payload
    );

    return response.data;
  }

  /**
   * 🗑️ DELETE GALLERY IMAGE
   */
  async deleteGalleryImage(
    id: string,
    index: number
  ): Promise<SuccessResponse> {
    const response = await apiClient.delete(
      env.ARTICLES.ADMIN.GALLERY_DELETE(id, index)
    );

    return response.data;
  }

  /**
   * 🚀 PUBLISH
   */
  async publishArticle(id: string): Promise<SuccessResponse> {
    const response = await apiClient.post(
      env.ARTICLES.ADMIN.PUBLISH(id)
    );

    return response.data;
  }

  /**
   * ⛔ UNPUBLISH
   */
  async unpublishArticle(id: string): Promise<SuccessResponse> {
    const response = await apiClient.post(
      env.ARTICLES.ADMIN.UNPUBLISH(id)
    );

    return response.data;
  }

  /**
   * ❌ DELETE
   */
  async deleteArticle(id: string): Promise<SuccessResponse> {
    const response = await apiClient.delete(
      `${env.ARTICLES.ADMIN.BASE}/${id}`
    );

    return response.data;
  }
}

/**
 * Export singleton
 */
export const adminArticlesService = new AdminArticlesService();